const apiBaseUrl = "https://www.myspeedymarket.fi/shopify";

/******************************************** 全局变量 *************************************/

/******************************************** 工具函数 *************************************/


// 获取公钥信息
async function getPublicKeyInfo() {
    const data = await getPublicKey();
    const publicKey = await importPublicKeyFromBase64String(data.publicKey);

    let publicKeyInfo = {
        publicKey: publicKey,
        code: data.code
    };
    return publicKeyInfo;
}

// 密钥生成参数
const keyGenParams = {
    name: "RSA-OAEP",
    modulusLength: 2048,    // 可以是1024, 2048, 或4096
    publicExponent: new Uint8Array([0x01, 0x00, 0x01]),
    hash: { name: "SHA-256" },
};

// 密钥导入参数
const keyImportParams = {
    name: "RSA-OAEP",
    hash: { name: "SHA-256" }
};

// 加密参数
const encryptParams = {
    name: "RSA-OAEP",
    hash: { name: "SHA-256" }
};

// 生成密钥对
async function generateKeyPair() {
    return await window.crypto.subtle.generateKey(
        keyGenParams,
        true, // 密钥是否可导出
        ["encrypt", "decrypt"] // 密钥用途
    );
}

// 从Base64字符串导入公钥
async function importPublicKeyFromBase64String(publicKeyBase64String) {
    // Base64解码
    const publicKeyByteArray = Uint8Array.from(atob(publicKeyBase64String), c => c.charCodeAt(0));

    return await window.crypto.subtle.importKey(
        "spki",
        publicKeyByteArray,
        keyImportParams,
        true,
        ["encrypt"]
    );
}

// 加密数据
async function encryptData(publicKey, data) {
    const encodedData = new TextEncoder().encode(data);
    let encryptBytes = await window.crypto.subtle.encrypt(
        encryptParams,
        publicKey,
        encodedData
    );

    let binary = '';
    let tempBytes = new Uint8Array(encryptBytes);
    const len = tempBytes.byteLength;
    for (let i = 0; i < len; i++) {
        binary += String.fromCharCode(tempBytes[i]);
    }
    return window.btoa(binary);
}

function getCurrentTimestamp() {
    // 创建表示当前时间的 Date 对象
    const now = new Date();

    // 获取时间各部分
    const year = now.getFullYear();             // 2025 (年份)
    const month = now.getMonth() + 1;           // 1-12 (月份，0-11所以要+1)
    const day = now.getDate();                  // 1-31 (日期)
    const hour = now.getHours();                // 0-23 (小时)
    const minute = now.getMinutes();            // 0-59 (分钟)
    const second = now.getSeconds();            // 0-59 (秒)
    const millisecond = now.getMilliseconds();  // 0-999 (毫秒)

    return `${String(year).padStart(4, '0')}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')} ` +
        `${String(hour).padStart(2, '0')}:${String(minute).padStart(2, '0')}:${String(second).padStart(2, '0')}.${String(millisecond).padStart(3, '0')}`;
}

// 生成GUID
function generateGUID() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        const r = Math.random() * 16 | 0;
        const v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}

// 生成订单号：SP + 9位数字（基于UUID保证唯一性）
function generateOrderNo() {
    // 生成UUID
    const uuid = generateGUID();
    
    // 将UUID转换为数字哈希值
    let hash = 0;
    for (let i = 0; i < uuid.length; i++) {
        const char = uuid.charCodeAt(i);
        hash = ((hash << 5) - hash) + char;
        hash = hash & hash; // 转换为32位整数
    }
    
    // 取绝对值并转换为9位数字字符串
    const numericString = Math.abs(hash).toString().padStart(9, '0');
    
    // 如果超过9位，取后9位
    const nineDigits = numericString.slice(-9);
    
    return 'SP' + nineDigits;
}

// 使用Promise包装FileReader
function readFileAsArrayBuffer(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.onload = (e) => resolve(e.target.result);
        reader.onerror = (e) => reject(new Error('文件读取失败'));

        reader.readAsArrayBuffer(file);
    });
}

// 使用Promise包装FileReader
function readFileAsArrayBufferBase64String(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.onload = (e) => {
            let tempString = '';
            let tempBytes = new Uint8Array(e.target.result);
            const len = tempBytes.byteLength;
            for (let i = 0; i < len; i++) {
                tempString += String.fromCharCode(tempBytes[i]);
            }
            resolve(window.btoa(tempString));
        };
        reader.onerror = (e) => reject(new Error('文件读取失败'));

        reader.readAsArrayBuffer(file);
    });
}


/******************************************** 后台OPEN_API *************************************/

async function getPublicKey() {
    const url = `${apiBaseUrl}/api/v1/front/auth/getPublicKey`
    const headers = {
        'Accept': '*/*',
    };

    try {
        const response = await fetch(url, {
            method: 'GET',
            headers: headers
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const result = await response.json();
        if (result.code === 0) {
            return result.data; // { publicKey, code }
        } else {
            throw new Error(`API error! msg: ${result.msg}`);
        }
    } catch (error) {
        console.error('Error fetching public key:', error);
        throw error;
    }
}

// 生成认证头部
// ── Front JWT（服务端 HS256 签发，不可伪造，替代可离线伪造的 t-env）──────────────
// 经 Shopify App Proxy 同源取令牌：storefront(speedynordic.fi) 上的相对路径 /apps/ordership/token
// → Shopify 附 HMAC 签名 + 注入登录客户 id → 后端验签后签发短时效 JWT。内存缓存 + 到期前自动重取。
let _frontToken = null;
let _frontTokenExpEpoch = 0; // 秒
// 正在进行中的领证请求。购物车页一打开会并发发出好几个要鉴权的请求，它们同时发现缓存是空的，
// 于是各自去领一张证（2026-09-18 实测：22 个业务请求打了 10 次领证）。让它们共享同一个进行中的
// 请求，一次只领一张。并发的 401 重试同理，不会把 App Proxy 打成一片。
let _frontTokenInflight = null;
async function getFrontToken(forceRefresh) {
    const now = Math.floor(Date.now() / 1000);
    // 提前 60s 视为过期，避免请求恰卡在到期边界
    if (!forceRefresh && _frontToken && now < _frontTokenExpEpoch - 60) {
        return _frontToken;
    }
    // 已有人在领：一起等那一张。在领的必定是新证，强刷也能复用，不会拿到刚被拒的旧证。
    if (_frontTokenInflight) {
        return _frontTokenInflight;
    }
    _frontTokenInflight = (async () => {
        // 必须走相对路径（同源 App Proxy）：apiBaseUrl 是跨域后端，拿不到 Shopify 登录态与签名
        const resp = await fetch('/apps/ordership/token', {
            headers: { 'Accept': 'application/json' },
            credentials: 'same-origin'
        });
        const json = await resp.json();
        if (json && json.code === 0 && json.data && json.data.token) {
            _frontToken = json.data.token;
            // 用领回来那一刻的时间算到期，别用进函数时的 now：并发等待期间时间会往前走
            _frontTokenExpEpoch = Math.floor(Date.now() / 1000) + (Number(json.data.expiresIn) || 900);
            return _frontToken;
        }
        _frontToken = null;
        _frontTokenExpEpoch = 0;
        throw new Error('获取登录凭证失败：' + (json && json.msg ? json.msg : '请确认已登录账户'));
    })();
    try {
        return await _frontTokenInflight;
    } finally {
        _frontTokenInflight = null;   // 成败都要清，否则失败一次就永远卡在这张废 promise 上
    }
}

async function generateAuthenticationHeaders() {
    const token = await getFrontToken();
    return { 'Authorization': 'Bearer ' + token };
}

// 带 Front JWT 的 fetch：**401 自动强刷令牌重试一次**。
// 2026-09-18 生产事故：客户结账弹「处理失败: HTTP error! status: 401」且不会自己好——
// 令牌一旦失效（页面开着超过 TTL、或客户端与服务端时钟有偏差导致前端以为还没到期），
// getFrontToken 的内存缓存会一直把这个死令牌交出去，而全项目没有一处传过 forceRefresh=true，
// 于是每次点结账都撞同一堵墙，只有关掉页面重开才恢复。
// 重试是安全的：401 由拦截器在进 controller 之前拒绝，请求没有任何副作用（不会重复建单/重复扣款）。
async function fetchWithAuth(url, options = {}) {
    const send = async (forceRefresh) => {
        const token = await getFrontToken(forceRefresh);
        const headers = Object.assign({}, options.headers || {}, { 'Authorization': 'Bearer ' + token });
        return fetch(url, Object.assign({}, options, { headers: headers }));
    };
    const resp = await send(false);
    if (resp.status !== 401) {
        return resp;
    }
    console.warn('[front-auth] 令牌失效(401)，强制重取后重试一次:', url);
    return send(true);
}

// 证件提醒（登录后）：与小程序 /api/v1/miniapp/cert/notices 同一份后端判定。
// 两档是不同的事，文案不能混：
//   certExpiring     = 证件【本身】快过期/已过期 → 客户得去【换证】，重传照片解决不了；
//                      blocking=true 表示这本证件下单会被硬拦（与后端 CertExpiryUtil.isBlocked 同口径）
//   retentionExpiring= 证件【影像】快到保留期要被我们删掉 → 提示【重新上传】一张
// 查不出来就返回空：提醒是加分项，绝不该让它挡住下单。
async function getCertNotices() {
    try {
        const resp = await fetchWithAuth(`${apiBaseUrl}/api/v1/front/cert/notices`, { method: 'GET' });
        const json = await resp.json();
        if (json && json.code === 0 && json.data) {
            return json.data;
        }
    } catch (e) {
        console.warn('证件提醒获取失败(忽略):', e);
    }
    return { retentionExpiring: [], certExpiring: [] };
}

// 订单
async function splitOrder(params) {
    return fetchWithAuth(`${apiBaseUrl}/api/v1/front/goods/split`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(params)
    })
        .then(response => response.json())
        .then(response => {
            if (response.code != 0) {
                throw new Error(response.msg);
            }
            return response.data;
        });
}

// 更新子单地址
async function updateSplitOrderAddress(orderId, batchNo, recipientAddress = null) {
    const requestBody = {
        orderId: orderId,
        batchNoCurrent: batchNo,
        batch_no_current: batchNo
    };

    if (recipientAddress) {
        requestBody.recipientAddress = recipientAddress;
        requestBody.recipient_address = recipientAddress;
    }

    return fetchWithAuth(`${apiBaseUrl}/api/v1/front/goods/updateAddress`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(requestBody)
    })
        .then(response => response.json())
        .then(response => {
            if (response.code != 0) {
                throw new Error(response.msg);
            }
            return response.data;
        });
}

async function confirmSplitOrder(orders) {
    return fetchWithAuth(`${apiBaseUrl}/api/v1/front/goods/confirm`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ orders: orders })
    })
        .then(response => response.json())
        .then(response => {
            if (response.code != 0) {
                throw new Error(response.msg);
            }
        });
}

// 获取中国省份
async function getChinaProvinces() {
    return fetch(`${apiBaseUrl}/api/v1/front/region/provinces`)
        .then(response => response.json())
        .then(response => {
            if (response.code != 0) {
                throw new Error(response.msg);
            }
            return response.data;
        });
}

// 按省份获取城市
async function getChinaCitiesByProvince(provinceCode) {
    return fetch(`${apiBaseUrl}/api/v1/front/region/cities?provinceCode=${provinceCode}`)
        .then(response => response.json())
        .then(response => {
            if (response.code != 0) {
                throw new Error(response.msg);
            }
            return response.data;
        });
}

// 按城市获取区
async function getChinaAreasByCity(cityCode) {
    return fetch(`${apiBaseUrl}/api/v1/front/region/districts?cityCode=${cityCode}`)
        .then(response => response.json())
        .then(response => {
            if (response.code != 0) {
                throw new Error(response.msg);
            }
            return response.data;
        });
}

// 地址智能识别：粘贴整段中文地址 → 后端解析成结构化字段(姓名/手机/省市区+码/详细/邮编/身份证)，邮编离线自动补齐
async function parseReceiverAddress(raw) {
    return fetch(`${apiBaseUrl}/api/v1/front/region/parseAddress`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ raw: raw })
    })
        .then(response => response.json())
        .then(response => {
            if (response.code != 0) {
                throw new Error(response.msg);
            }
            return response.data;
        });
}

// 查询所有的发件人地址
async function getAllSenderAddresses() {
    return fetchWithAuth(`${apiBaseUrl}/api/v1/front/address/sender/getUserById`, {})
        .then(response => response.json())
        .then(response => {
            if (response.code != 0) {
                throw new Error(response.msg);
            }
            return response.data;
        });
}

// 删除指定的发件人地址
async function deleteSenderAddress(id) {
    return fetchWithAuth(`${apiBaseUrl}/api/v1/front/address/sender/delete?id=${id}`, {
        method: 'DELETE'
    })
        .then(response => response.json())
        .then(response => {
            if (response.code != 0) {
                throw new Error(response.msg);
            }
            return response.data;
        });
}

// 添加获取更新发件人地址
async function addOrUpdateSenderAddress(addressInfo) {
    return fetchWithAuth(`${apiBaseUrl}/api/v1/front/address/sender/createOrUpdate`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(addressInfo)
    })
        .then(response => response.json())
        .then(response => {
            if (response.code != 0) {
                throw new Error(response.msg);
            }
        });
}

// 查询所有的收件人地址
async function getAllReceiverAddresses() {
    return fetchWithAuth(`${apiBaseUrl}/api/v1/front/address/recipient/getByUserId`, {})
        .then(response => response.json())
        .then(response => {
            if (response.code != 0) {
                throw new Error(response.msg);
            }
            return response.data;
        });
}

// 删除指定的收件人地址
async function deleteReceiverAddress(id) {
    return fetchWithAuth(`${apiBaseUrl}/api/v1/front/address/recipient/delete?id=${id}`, {
        method: 'DELETE'
    })
        .then(response => response.json())
        .then(response => {
            if (response.code != 0) {
                throw new Error(response.msg);
            }
            return response.data;
        });
}

// 添加获取更新收件人地址
async function addOrUpdateReceiverAddress(addressInfo) {
    return fetchWithAuth(`${apiBaseUrl}/api/v1/front/address/recipient/createOrUpdate`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(addressInfo)
    })
        .then(response => response.json())
        .then(response => {
            if (response.code != 0) {
                throw new Error(response.msg);
            }
        });
}

/** 从 /cart.js 的 token 解析 cartId 与 key */
function parseCartToken(token) {
    if (!token || typeof token !== 'string' || !token.includes('?key=')) {
        throw new Error('购物车 token 无效，请刷新购物车页面');
    }
    const parts = token.split('?key=');
    const cartId = parts[0];
    const key = parts[1];
    if (!cartId || !key) {
        throw new Error('购物车 token 无效，请刷新购物车页面');
    }
    return { cartId, key };
}

// 同步购物车信息
async function syncCartInfo(cartId, key) {
  try {
    const response = await fetchWithAuth(
      `${apiBaseUrl}/api/v1/webhook/shopify/cart/info`,
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ cartId, key }),
      }
    );

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const responseData = await response.json();
    if (responseData.code != 0) {
      throw new Error(responseData.msg);
    }

    return responseData.data;
  } catch (error) {
    console.error('Error syncing cart info:', error);
    throw error;
  }
}

/******************************************** 和shopify后台服务交互 *************************************/

// 获取当前登录的用户ID
async function getCustomerId() {
    // TODO 本地开发环境，返回模拟客户ID
    if (window.location.hostname === '127.0.0.1' || window.location.hostname === 'localhost') {
        console.log('本地开发环境，返回模拟客户ID: wanhouchao');
        return 'wanhouchao';
    }

    // try {
    //     const response = await fetch('/account.json');
        
    //     // If the response is not OK (e.g., 404 Not Found), it means the customer is not logged in.
    //     if (!response.ok) {
    //         throw new Error("当前未登录");
    //     }

    //     const data = await response.json();

    //     if (data.customer) {
    //         console.log('客户ID:', data.customer.id);
    //         return data.customer.id;
    //     } else {
    //         throw new Error("当前未登录");
    //     }
    // } catch (error) {
    //     console.error('获取客户ID时出错:', error.message);
    //     // Throw a new error to ensure the calling function knows about the failure.
    //     // We can check if the message is one we already set to avoid nesting "Error: Error: ..."
    //     if (error.message === "当前未登录") {
    //         throw error;
    //     }
    //     throw new Error("获取客户ID失败");
    // }

    if (window.customerData && window.customerData.loggedIn) {
        return window.customerData.id;
    // 使用客户 ID
    } else {
        throw new Error("当前未登录");
    }
};

// 获取购物车信息
async function getCartInfo() {
    return await fetch('/cart.js')
        .then(response => response.json())
        .catch(err => {
            console.log('获取购物车信息失败：', err);
            throw new Error("从shopify获取购物车信息失败");
        });
}

// 更新购物车属性
async function updateCartAttributes(attributes) {
    const response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ attributes })
    })
        .catch(err => {
            throw new Error('更新购物车属性失败');
        });

    if (!response.ok) {
        throw new Error('更新购物车属性失败');
    }

    return response.json();
}